<template class="h-screen">

  <head>
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link
      href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
      rel="stylesheet">
  </head>
  
  <body class="box-border flex relative flex-col shrink-0 bg-gradient-to-b from-slate-700 to-slate-900 max-h-screen min-h-screen">
    <PbHeader :menuItems="menuItems" :rightMenuItems="rightMenuItems" class="bg-white min-w-full sticky top-0 z-10 "></PbHeader>
    <RouterView class="flex-grow"></RouterView>
  </body>

</template>

<script>
import { loadScript } from "vue-plugin-load-script";
loadScript("https://accounts.google.com/gsi/client");
import { mapMutations, mapGetters } from "vuex";
import PbHeader from './components/PbHeader.vue'
import { store } from './store.js'
import axios from "axios";
import 'primeicons/primeicons.css'
export default {
  name: 'App',
  components: { PbHeader },
  data() {
    return {
      menuItems: [
        { text: 'Home', to: '/' },
        { text: 'About', to: '/about' },
        { text: 'Contact', to: '/contact' },
      ],
      store
    }
  },

  mounted() {
    console.log("Mounted");
    console.log(this.$cookies.get('pb_user'));
    console.log(this.$cookies.get('pb_token'));
    if (this.$cookies.get('pb_user') !== undefined && this.$cookies.get('pb_user') !== null && this.$cookies.get('pb_user') !== "") {
      console.log("Logging in");
      this.store.logIn();
    }
  },
  computed: {
    rightMenuItems() {
      if (this.store.loggedIn) {
        return [
          { text: 'Profile', to: '/profile', click: null },
          { text: 'Logout', to: '/landing', click: () => this.logout() },
        ];
      } else {
        return [
          { text: 'Login', to: '/login' },
          { text: 'Signup', to: '/signup' },
        ];
      }
    }
  },
  methods: {
    getRightMenuItems() {

      var user = this.$cookies.get('pb_user');
      console.log(`User: ${user}`)

      if (user !== undefined && user !== null && user !== "") {
        return [
          { text: 'Profile', to: '/profile', click: null },
          { text: 'Logout', to: '/landing', click: () => this.logout() },
        ];
      } else {
        return [
          { text: 'Login', to: '/login' },
          { text: 'Signup', to: '/signup' },
        ];
      }
    },
    logout() {
      console.log("Logging out");
      const headers = {
        'Token': `Bearer ${this.$cookies.get('pb_token')}`,
        'User': this.$cookies.get('pb_user'),
        'Content-Type': 'application/json'
      }
      axios.post(`${process.env.VUE_APP_BASE_URL}/logout`, null, {
        headers: headers
      }).then((response) => {
        console.log(response);
        this.$cookies.remove('pb_user');
        this.$cookies.remove('pb_token');
        this.store.logOut();
        this.$router.push("/landing");
      }).catch((error) => {
        console.log(error);
      });
    },
    computed: {

    },
  }
  ,
}
</script>

<style>
body {
  margin: 0;
}
::-webkit-scrollbar {
  width: 0.7em;
  background: rgba(255, 255, 255, 0);
}
::-webkit-scrollbar-thumb {
  background: #ffffff59;
  height:30px;
}

::-webkit-scrollbar-track-piece
{
   display:none;
}
</style>